import { AssetTypes, BlockType, getBlockFormFieldName, IncomeTypes } from '@common/entities';
import { GENERAL_QUESTION_FIELDS } from '@common/ui';

import { BlockFieldSubField } from 'types/fields';

import { getIdentificationTypeFieldMap } from './get-identification-type-field-map';

interface CreateBlockFieldMappingOptions {
  blockType: BlockType;
  configuration: any;
  formFieldPrefix: string;
  subType?: IncomeTypes | AssetTypes | string;
}

const getDefaultBlockFieldMapping = (args: CreateBlockFieldMappingOptions) => {
  const { blockType, configuration, formFieldPrefix, subType } = args;
  const fields = Array.isArray(configuration?.fields) ? configuration.fields : [];

  return fields
    .filter((field: BlockFieldSubField) => field.enabled)
    .map((field: BlockFieldSubField) => ({
      blockFieldName: getBlockFormFieldName(
        blockType,
        field.name,
        subType as IncomeTypes | AssetTypes,
      ),
      blockFieldFormFieldName: formFieldPrefix ? `${formFieldPrefix}.${field.name}` : field.name,
    }));
};

export const getGeneralQuestionFieldMap = (args: CreateBlockFieldMappingOptions) => {
  const { configuration } = args;

  const excludedNames = GENERAL_QUESTION_FIELDS.filter((field) => field?.isDependent).map(
    (field) => field.name,
  );

  const excludedFields = configuration.fields.filter(
    (field: BlockFieldSubField) => !excludedNames.includes(field.name),
  );
  return getDefaultBlockFieldMapping({
    ...args,
    configuration: { ...configuration, fields: excludedFields },
  });
};

const BLOCK_TYPE_MAPPER_FUNCTIONS = {
  [BlockType.GeneralQuestion]: getGeneralQuestionFieldMap,
  [BlockType.IdentificationType]: ({ configuration }: CreateBlockFieldMappingOptions) =>
    getIdentificationTypeFieldMap(configuration),
};

export const getFieldMappingForBlockType = (args: CreateBlockFieldMappingOptions) => {
  const { blockType } = args;
  const mapperFunction =
    BLOCK_TYPE_MAPPER_FUNCTIONS[blockType as keyof typeof BLOCK_TYPE_MAPPER_FUNCTIONS];
  if (!mapperFunction) {
    return getDefaultBlockFieldMapping(args);
  }
  return mapperFunction(args);
};
